import ExcelJS from 'exceljs';

function triggerDownload(buffer, filename) {
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}

export async function downloadJsonAsExcel(rows, sheetName, filename) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    if (rows.length > 0) {
        const headers = Object.keys(rows[0]);
        worksheet.columns = headers.map((header) => ({ header, key: header }));
        worksheet.addRows(rows);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    triggerDownload(buffer, filename);
}

export async function readExcelFileAsRows(file) {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(await file.arrayBuffer());
    const worksheet = workbook.worksheets[0];

    if (!worksheet) {
        return [];
    }

    const rows = [];
    worksheet.eachRow((row) => {
        rows.push(row.values.slice(1).map((value) => (value ?? '')));
    });
    return rows;
}
